module.exports = __webpack_public_path__ + "img/logo.260222d4.png";